module.exports = __webpack_public_path__ + "assets/img/star_sentence_un1.68a91b61.png";